import { render, staticRenderFns } from "./RequirementsSection.vue?vue&type=template&id=3f68e3af&scoped=true&lang=html&"
import script from "./RequirementsSection.vue?vue&type=script&lang=js&"
export * from "./RequirementsSection.vue?vue&type=script&lang=js&"
import style0 from "./RequirementsSection.vue?vue&type=style&index=0&id=3f68e3af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f68e3af",
  null
  
)

export default component.exports